module.exports = __webpack_public_path__ + "img/logo.948471dd.svg";